import { render, staticRenderFns } from "./GuppyChatPrivateList.vue?vue&type=template&id=ebc0e366&scoped=true&"
import script from "./GuppyChatPrivateList.vue?vue&type=script&lang=js&"
export * from "./GuppyChatPrivateList.vue?vue&type=script&lang=js&"
import style0 from "./GuppyChatPrivateList.vue?vue&type=style&index=0&id=ebc0e366&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebc0e366",
  null
  
)

export default component.exports